"use strict";

exports.__esModule = true;
exports.MultiDeviceSelector = MultiDeviceSelector;
exports.getKey = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _devicePredicate = require("../../../Utils/devicePredicate");
var _excluded = ["devices", "tags", "selected", "onSelect", "shouldSelectAllFiltered"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getKey = exports.getKey = function getKey(item) {
  return item.uuid;
};
var getGroups = function getGroups(tags) {
  return tags.reduce(function (groups, tag) {
    groups[tag] = function (item) {
      return item.tags.includes(tag);
    };
    return groups;
  }, {});
};
function MultiDeviceSelector(props) {
  var _props$showItemCount = props.showItemCount,
    showItemCount = _props$showItemCount === void 0 ? false : _props$showItemCount;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = props.devices,
    tags = props.tags,
    selected = props.selected,
    onSelect = props.onSelect,
    shouldSelectAllFiltered = props.shouldSelectAllFiltered,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var groups = getGroups(tags);
  var allPlaceholder = showItemCount ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MultiDeviceSelector.placeholder.all",
    defaultMessage: "(All devices selected)"
  }) : undefined;
  return /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxList, _extends({
    groups: groups,
    selected: selected,
    items: devices,
    itemPredicate: _devicePredicate.devicePredicate,
    renderItemText: function renderItemText(item) {
      return item.name;
    },
    renderItemLabel: function renderItemLabel(item) {
      return item.uuid;
    },
    renderCountText: function renderCountText(value, isAll) {
      return isAll ? allPlaceholder : translate("MultiDeviceSelector.countText", "{value} {value, plural, one {device} other {devices}} selected", {
        value: value
      });
    },
    getKey: getKey,
    onSelect: onSelect,
    icon: _icons.IconNames.BOX,
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "MultiDeviceSelector.placeholder",
      defaultMessage: "Select Devices"
    }),
    allPlaceholder: allPlaceholder,
    searchPlaceHolder: translate("MultiDeviceSelector.search.placeholder", "Search Device"),
    shouldSelectAllFiltered: shouldSelectAllFiltered
  }, extra));
}